import { useEffect, useState } from 'react';
import { useGetWarehouseAddress } from '@steelbuy/data-access';
import { AddressModel } from '@steelbuy/ts-shared';
import { CardContentCheckoutAddresses } from '@steelbuy/ui-domain';
import { CardLayout } from '@steelbuy/ui-primitive';
import { useCreateListingContext } from '../CreateListingContext';

type CollectionAddressesProps = {
    pickupAddressId?: string;
    forceValidation: boolean;
    isMandatory?: boolean;
    showNotification?: boolean;
    selectedPickupAddressId?: (id: string) => void;
    selectedPickupAddress?: (address?: AddressModel) => void;
};

const CollectionAddresses = ({
    pickupAddressId,
    forceValidation,
    isMandatory = false,
    showNotification,
    selectedPickupAddressId,
    selectedPickupAddress,
}: CollectionAddressesProps) => {
    const { data: addressCollectionItems } = useGetWarehouseAddress();
    const [address, setAddress] = useState(pickupAddressId ?? '');
    const { updatePickupAddressStepData } = useCreateListingContext();

    useEffect(() => {
        if (pickupAddressId) {
            setAddress(pickupAddressId);
        }
    }, [pickupAddressId]);

    return (
        <section>
            <CardLayout>
                {addressCollectionItems && (
                    <CardContentCheckoutAddresses
                        addresses={addressCollectionItems}
                        selectedAddress={address}
                        forceValidation={forceValidation}
                        onSelectionChanged={(newAddressId) => {
                            setAddress(newAddressId);
                            updatePickupAddressStepData({
                                pickupAddressId: newAddressId,
                            });
                            selectedPickupAddressId?.(newAddressId);
                            selectedPickupAddress?.(
                                addressCollectionItems.find((addressModel) => addressModel.id === newAddressId)
                            );
                        }}
                        isMandatory={isMandatory}
                        showNotification={showNotification}
                    />
                )}
            </CardLayout>
        </section>
    );
};

export default CollectionAddresses;
